@if (isLoading || totalPendingActionsCount > 0) {
  <section
    class="pending-actions-card"
    [class.pending-actions-card-collapsed]="!isPendingActionsExpanded"
    id="tour-pending-actions-section"
  >
    <div class="pending-actions-header">
      <div class="pending-actions-header-content">
        <div>
          <h2 class="pending-actions-title">Pending Actions</h2>
          <p class="pending-actions-subtitle">Review pending actions.</p>
        </div>
        <div class="pending-actions-controls">
          @if (!isPendingActionsExpanded && totalPendingActionsCount > 0) {
            <span class="pending-actions-count-badge">
              {{ totalPendingActionsCount }}
            </span>
          }
          <button
            type="button"
            class="toggle-btn"
            (click)="togglePendingActions()"
            [attr.aria-label]="
              isPendingActionsExpanded
                ? 'Collapse pending actions'
                : 'Expand pending actions'
            "
            [attr.aria-expanded]="isPendingActionsExpanded"
          >
            <svg
              class="toggle-icon"
              [class.expanded]="isPendingActionsExpanded"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19 9l-7 7-7-7"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    @if (isPendingActionsExpanded) {
      <div class="pending-actions-list">
        @if (isLoading) {
          <div class="skeleton-card">
            <div class="skeleton skeleton-count"></div>
            <div class="skeleton-info">
              <div class="skeleton skeleton-label"></div>
              <div class="skeleton skeleton-message"></div>
              <div class="skeleton skeleton-button"></div>
            </div>
          </div>
          @if (hasAdminPrivilege) {
            <div class="skeleton-card">
              <div class="skeleton skeleton-count"></div>
              <div class="skeleton-info">
                <div class="skeleton skeleton-label"></div>
                <div class="skeleton skeleton-message"></div>
                <div class="skeleton skeleton-button"></div>
              </div>
            </div>
            <div class="skeleton-card">
              <div class="skeleton skeleton-count"></div>
              <div class="skeleton-info">
                <div class="skeleton skeleton-label"></div>
                <div class="skeleton skeleton-message"></div>
                <div class="skeleton skeleton-button"></div>
              </div>
            </div>
          }
        } @else {
          @if (pendingLeadAssignmentsCount > 0) {
            <div class="card lead-status-action-card">
              <div class="count">{{ pendingLeadAssignmentsCount }}</div>
              <div class="info">
                <div>
                  <div class="label">
                    Pending Lead Status Assignment{{
                      pendingLeadAssignmentsCount === 1 ? "" : "s"
                    }}
                  </div>
                  <div class="message">
                    {{
                      pendingLeadAssignmentsCount === 1
                        ? "One lead is"
                        : "Leads are"
                    }}
                    waiting for status review.
                  </div>
                </div>
                <div>
                  <button
                    type="button"
                    class="alert-btn"
                    (click)="onReviewLeadStatus()"
                  >
                    <span>Review Now</span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M13 7L18 12M18 12L13 17M18 12H6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          }
          @if (hasAdminPrivilege) {
            @if (pendingSignupRequestsCount > 0) {
              <div class="card signup-card">
                <div class="count">{{ pendingSignupRequestsCount }}</div>
                <div class="info">
                  <div>
                    <div class="label">
                      Pending Signup Request{{
                        pendingSignupRequestsCount === 1 ? "" : "s"
                      }}
                    </div>
                    <div class="message">
                      You have
                      {{ pendingSignupRequestsCount === 1 ? "an" : "" }}
                      application{{
                        pendingSignupRequestsCount === 1 ? "" : "s"
                      }}
                      waiting for review.
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="alert-btn"
                      (click)="navigateToSignupRequests()"
                    >
                      <span>Review Now</span>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M13 7L18 12M18 12L13 17M18 12H6"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (pendingPdmApprovalCount > 0) {
              <div class="card approval-card">
                <div class="count">{{ pendingPdmApprovalCount }}</div>
                <div class="info">
                  <div>
                    <div class="label">
                      Pending PDM File Approval{{
                        pendingPdmApprovalCount === 1 ? "" : "s"
                      }}
                    </div>
                    <div class="message">
                      You have
                      {{ pendingPdmApprovalCount === 1 ? "an" : "" }} PDM file{{
                        pendingPdmApprovalCount === 1 ? "" : "s"
                      }}
                      waiting for review.
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="alert-btn"
                      (click)="navigateToPdmRequests()"
                    >
                      <span>Review Now</span>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M13 7L18 12M18 12L13 17M18 12H6"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            }
          }
        }
      </div>
    }
  </section>
}
